// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class PopupModal extends Component {
  activeClass = 'popup-modal--show';

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.addListener(Notifications.TOGGLE_MODAL, this.handleToggleModal);
  }

  /**
   * Toggle the modal.
   */
  handleToggleModal({ id }: { id: string }): void {
    if (!id || id !== this.el.id) return;

    this.el.classList.toggle(this.activeClass);

    if (this.el.dataset.toggleScrollState) {
      this.notify(Notifications.TOGGLE_SCROLLBAR_STATE, {
        keepCurrentPosition: !!this.el.dataset.keepCurrentPosition
      });
    }
  }
}
